import React, { useState, useEffect, useRef } from 'react';
import { InputGroup } from 'react-bootstrap';
import StringToIcon, { usableIcons } from '../../../StringToIcon/StringToIcon';
import './styles/Icon.scss'

export default function Icon(props) {
    const value = props.value;

    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    const [display, setDisplay] = useState(false);


    const ref = useRef(null);
    const buttonClick = () => setDisplay(!display);

    useEffect(() => {
        function handleClickOutside(event) {
            // @ts-ignore
            if (ref.current && !ref.current.contains(event.target)) {
                setDisplay(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [ref])


    return (
        <InputGroup className="mb-3" >
            {props.title != undefined ?
                <InputGroup.Prepend>
                    <InputGroup.Text>{props.title}</InputGroup.Text>
                </InputGroup.Prepend>
                : null}
            <div className="container form-control" onClick={() => buttonClick()}>

                <p style={{ margin: "0px", fontSize: "16px" }}>{(props.value == undefined || props.value == "") ? (props.options != undefined && props.options.selectText != undefined ? props.options.selectText : "Klikk for å velge ikon") : ""}</p>
                <StringToIcon icon={{ icon: value }} ></StringToIcon>

                {display && (
                    <div className="pickercontainer" onClick={(e) => e.stopPropagation()}>
                        <div className="pickerTriangle"></div>
                        <div className="iconHeader">
                            {props.title != undefined ?
                                <div>{props.title}</div>
                            : null}
                        </div>
                        <div className="listContainer">
                            {usableIcons.map((i, index) => (
                                <div className="iconcontainer" key={index}>
                                    <StringToIcon
                                        icon={i}
                                        onClick={() => {
                                            handleChange(i);
                                            setDisplay(false);
                                        }} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </InputGroup>

    )
}